<template>
  <div class="row">
    <div class="col-lg-12 mt-2">
      <div style="display: flex">
        <input
          type="text"
          class="form-control"
          placeholder="Faça uma busca"
          v-model="search"
          style="width: 285px"
        />
        <button
          class="btn btn-outline-primary"
          title="Limpar"
          @click="clearFilter"
        >
          Limpar
        </button>

        <b-form-select
          v-model="selected"
          :options="options"
          class="ml-4"
          style="width: 285px"
        ></b-form-select>
      </div>
      <div style="max-height: 100vh; overflow-x: auto">
        <b-table
          id="my-table"
          v-if="!loading"
          class="mt-4"
          hover
          :items="itemsFiltered"
          :fields="fields"
        >
          <template v-slot:cell(id)="row">
            {{ row.item.user ? row.item.user : '-' }}
          </template>
          <template v-slot:cell(date)="row">
            {{ row.item.date }} ás {{ row.item.time }}
          </template>
        </b-table>
      </div>

      <!-- <b-pagination
        v-if="!loading"
        aria-controls="my-table"
        v-model="currentPage"
        :total-rows="itemsFiltered.length"
        :per-page="perPage"
      ></b-pagination> -->

      <div v-show="!loading" class="pagination-area-logs">
        <paginate
          v-model="currentPage"
          :pageCount="Math.ceil(totalItems / perPage)"
          :clickHandler="getDataList"
          :prevText="'‹'"
          :nextText="'›'"
          :activeClass="'active'"
          :containerClass="'pagination b-pagination'"
          :pageClass="'page-item'"
        ></paginate>
      </div>

      <div v-if="loading" class="text-center mt-4">
        <b-spinner
          variant="success"
          type="grow"
          label="Spinning"
          class="bg-primary mt-4"
        ></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate';
import api from '../../../services/api';

export default {
  data: () => ({
    userAuth: null,
    fields: [],
    itemsFiltered: [],
    selected: 'all',
    search: '',
    options: [
      { value: null, text: 'Filtro por tipo' },
      { value: 'action', text: 'Ação' },
      { value: 'users', text: 'Usuários' },
      { value: 'alert', text: 'Alertas' },
      { value: 'all', text: 'Todos' },
    ],
    items: [],
    loading: false,
    perPage: 10,
    currentPage: 1,
    totalItems: 0,
  }),

  components: { Paginate },

  methods: {
    filterItens() {
      this.getDataList();
    },

    clearFilter() {
      this.selected = null;
      this.search = '';
      this.getDataList();
    },

    async getDataList() {
      this.loading = true;
      this.items = await api.get(`/audit-trail`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          typeSelected: this.selected,
          searchInput: this.search ? this.search : null,
          language: this.$i18n.locale,
          page: this.currentPage,
          limit: this.perPage,
        },
      });

      this.itemsFiltered = this.items.data.auditTrails;
      this.totalItems = this.items.data.totalAuditTrails;
      this.perPage = this.items.data.limit;
      this.currentPage = this.items.data.page;

      this.loading = false;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.getDataList();

    this.fields = [
      {
        key: 'id',
        label: 'Usuario',
        sortable: true,
      },
      {
        key: 'activity',
        label: 'Mudança realizada',
      },
      {
        key: 'type',
        label: 'Tipo',
      },
      {
        key: 'date',
        label: 'Quando',
        sortable: true,
      },
    ];
  },

  watch: {
    selected: function watchOptionSelected() {
      this.filterItens();
    },
    search: function watchSearch() {
      this.filterItens();
    },
  },
};
</script>

<style scoped>
.input-area {
  display: flex;
  flex-direction: row;
}

.pagination-area-logs >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.pagination-area-logs .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-logs a {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/log-recording/index.vue